
import { Component, Prop } from 'vue-property-decorator'
import { dataLayer, ga4Token } from '../core/constants'
import {
  PROP_AMOUNT_ID,
  PROP_MIN_AMOUNT_ID,
  PROP_UNIT_ID,
  PROP_ICONS_LIST,
  PROP_VIDEO_ID,
  IMAGE_GROUP_NAME_MAIN,
  IMAGE_GROUP_NAME_DETAILS,
  IMAGE_GROUP_NAME_ADDITIONAL,
  IMAGE_GROUP_APPLICATION,
  IMAGE_GROUP_NAME_DIMENSIONAL_DRAWING,
  IMAGE_GROUP_NAME_MOUNTING,
  IMAGE_GROUP_TO_SHOW,
  ATTR_UNITOFMEASURE,
  ATTR_PROPERTYGROUP_ID } from '../helpers/constants'
import { findPropWithId, findPropWithIdForIcons } from '../helpers/functions'
import Mixin from '../helpers/mixin'
import { IFilter, IFilterValue } from '../helpers/types'

@Component({})
export default class Product extends Mixin {
  @Prop() headerHeight: number
  @Prop({ default: false }) isBeStore: boolean
  @Prop() product: any
  @Prop() categoryTitle: any
  @Prop({ default: '' }) placeholder: string

  @Prop({ default: [] }) productFiltersToShow: string[]

  modelFilters: { [key: string]: any } = {}

  filters: IFilter[] = []
  foundVariations: any = []

  get variantSku(): string {
    return this.foundVariations.length === 1 || this.product.selectedVariantId ? this.getVariant().sku : '-'
  }

  get isVariant(): boolean {
    return this.foundVariations.length === 1 || this.product.selectedVariantId
  }

  get heroTitle(): string {
    return this.foundVariations.length === 1 || this.product.selectedVariantId
      ? this.getVariant().title
      : this.product.title
  }

  get heroDescription(): string {
    if (this.isVariant) {
      const variant = this.getVariant()

      if (variant.descriptionCommercial) return variant.descriptionCommercial
      // else if(variant.descriptionDefault) return (variant.descriptionDefault);
      // else if(variant.description) return (variant.description);
      else if (this.product.descriptionCommercial) return this.product.descriptionCommercial
      else if (this.product.descriptionDefault) return this.product.descriptionDefault
      else if (this.product.description) return this.product.description
    } else {
      if (this.product.descriptionCommercial) return this.product.descriptionCommercial
      if (this.product.descriptionDefault) return this.product.descriptionDefault
      if (this.product.description) return this.product.description
    }

    return ''
  }

  get amount(): string {
    return findPropWithId(this.getVariant().properties, PROP_MIN_AMOUNT_ID, '1')
  }

  get salesunit(): string {
    return findPropWithId(this.getVariant().properties, PROP_AMOUNT_ID, '1')
  }

  get unit(): string {
    // Previous solution, with measureUnit field
    // return this.foundVariations.length > 0 ? this.getVariant().measureUnit : ''

    // Current solution, could be no measureUnit field
    return this.getVariant().measureUnit
      ? this.getVariant().measureUnit
      : findPropWithId(this.getVariant().properties, PROP_UNIT_ID, '')
  }

  // Previous solution, now we use getCombinedAssets
  get assets(): any {
    return this.isVariant ? this.getVariant().assets : this.product.assets
  }

  get getCombinedAssets(): any {
    if (this.isVariant) {
      const variantAssets = this.getVariant()?.assets
      const productAssets = this.product?.assets;

      if (!variantAssets || variantAssets.length === 0) {
        return productAssets ?? []
      }

      const groupSet = new Set(variantAssets.map((item: any) => item.group));
      const combinedAssets = variantAssets.concat()

      if (Array.isArray(productAssets)) {
        productAssets.forEach((item: any) => {
          if (!groupSet.has(item.group)) {
            combinedAssets.push(item)
          }
        });
      }

      return combinedAssets
    } else {
      return this.product?.assets ?? []
    }
  }

  get properties(): any {
    return this.isVariant ? this.getVariant().properties : this.product.properties
  }

  // Previous solution, now we use getCombinedAllImages
  get allImages(): any {
    return this.isVariant ? this.getVariant().images : this.product.images;
  }

  get getCombinedAllImages(): any {
    if (!this.getVariant()?.images && !this.product?.images) {
      return []
    }
    if (this.isVariant) {
      if (!this.getVariant().images || this.getVariant().images?.length === 0) {
        return this.product.images?.filter((item: any) => IMAGE_GROUP_TO_SHOW.includes(item.group)) || []
      }

      const groupSet = new Set(this.getVariant().images?.map((item: any) => item.group))
      const combinedImages = this.getVariant().images?.concat()

      this.product.images?.forEach((item: any) => {
        if (IMAGE_GROUP_TO_SHOW.includes(item.group) && !groupSet.has(item.group)) {
          combinedImages.push(item);
        }
      });

      return combinedImages || []
    } else {
      return this.product.images?.filter((item: any) => IMAGE_GROUP_TO_SHOW.includes(item.group)) || []
    }
  }

  get sliderImages(): any {
    return this.getCombinedAllImages?.filter((item: any) => item.group == IMAGE_GROUP_NAME_MAIN || item.group == IMAGE_GROUP_NAME_ADDITIONAL)
  }

  get mediaImages(): any {
    return this.getCombinedAllImages?.filter(
      (item: any) =>
        item.group == IMAGE_GROUP_NAME_MAIN
        || item.group == IMAGE_GROUP_NAME_DETAILS
        || item.group == IMAGE_GROUP_NAME_ADDITIONAL
        || item.group == IMAGE_GROUP_APPLICATION)
  }

  get dimensionDrawingImages(): any {
    return this.getCombinedAllImages?.filter((item: any) => item.group === IMAGE_GROUP_NAME_DIMENSIONAL_DRAWING)
  }

  get montageImages(): any {
    return this.getCombinedAllImages?.filter((item: any) => item.group === IMAGE_GROUP_NAME_MOUNTING)
  }

  get iconsList(): any {
    if (this.isVariant) {
      const icons: any = [];
      // Used before - findPropWithIdMultiplyValues, now - findPropWithIdForIcons
      // Could be returned to findPropWithIdMultiplyValues if correct images will be added to the code
      findPropWithIdForIcons(this.getVariant().properties, PROP_ICONS_LIST).map((item: any) => {
        icons.push({
          name: item.value,
          url: '/' + item.value.replace(/:/g, '-').replace(/\+/g, '-').replace(/ /g, '-').replace(/\//g, '-') + '.jpg'
        })
      })
      return icons
    } else {
      return []
    }
  }

  get showVariantTable(): boolean {
    if ((this.productFiltersToShow && this.productFiltersToShow.length > 0) || this.product.variations.length == 1) {
      return false
    }
    return true
  }

  get youtubeVideoId(): any {
    // if it is a variant, try to return the variant video property value
    if (this.isVariant) {
      const variantVideoProperty = this.getVariant().properties.find((property: any) => property.id && property.id.includes(PROP_VIDEO_ID))
      if (variantVideoProperty && variantVideoProperty.value && variantVideoProperty.value !== '') {
        return variantVideoProperty.value
      }
    }
    // if it is not a variant, or there is no variant video property value, try to return the master video property value
    const masterVideoProperty = this.product.properties.find((property: any) => property.id && property.id.includes(PROP_VIDEO_ID))
    if (masterVideoProperty && masterVideoProperty.value && masterVideoProperty.value !== '') {
      return masterVideoProperty.value
    }
    return null
  }

  isSectionId(prop: any, sectionId: string): boolean {
    return prop.attributes.filter((item: any) => item.name === ATTR_PROPERTYGROUP_ID)[0]?.value === sectionId
  }

  propUnit(prop: any): string {
    return prop.attributes.filter((item: any) => item.name === ATTR_UNITOFMEASURE)[0]?.value || '';
  }

  removeHTML(str: any): any {
    const tmp = document.createElement('div')
    tmp.innerHTML = str
    return tmp.textContent || tmp.innerText || ''
  }

  getVariant() {
    if (this.product.selectedVariantId) {
      return this.product.variations.find((variant: any) => variant.id === this.product.selectedVariantId)
    } else return this.foundVariations[0]
  }


  getAssociations() {
    return this.isVariant
      ? (this.product.associations ?? []).concat(this.getVariant()?.associations ?? [])
      : (this.product.associations ?? []);
  }

  groupAssociations(associations: any): any {
    const groupedByType = associations.reduce((result: any, item: any) => {
      const existing = result.find((e: any) => {
        return e.category === item?.type
      })
      if (existing) {
        existing.value.push(item)
      } else {
        result.push({ category: item?.type || '', value: [item] })
      }
      return result
    }, [])

    const sortedResult = groupedByType
      .sort((a: any, b: any) => b.value.length - a.value.length)
      .map((q: any) => ({
        ...q,
        value: q.value.sort((a: any, b: any) =>
          Number(a.product.sku) - Number(b.product.sku)
        )
      }));

    return sortedResult;
  }

  // search through all the variations to find all possible values for every property taht should be a filter
  createFilters(): IFilter[] {
    return this.product.variations
      .map((variation: any) => {
        return variation.properties
          .filter((property: any) => this.productFiltersToShow.indexOf(property.id) >= 0)
          .map((property: any) => {
            const disableValue = this.foundVariations?.find((item: any) => item.id === variation.id) === null
            const unitValue = property.attributes.filter((item: any) => item.name === ATTR_UNITOFMEASURE)[0]?.value || ''
            return {
              title: property.displayName,
              values: [{ unit: unitValue, filterId: property.id, value: property.value, $isDisabled: disableValue }],
              id: property.id
            }
          })
      })
      .flat()
      .reduce((acc: IFilter[], filterList: IFilter) => {
        const id = filterList.id
        const index = acc.findIndex((item) => item.id === id)
        if (index < 0) {
          acc.push({
            title: filterList.title,
            values: filterList.values,
            placeholder: this.placeholder,
            id: filterList.id
          })
        } else {
          if (acc[index].values.find((value) => value.value === filterList.values[0].value)) return acc
          acc[index].values.push(filterList.values[0])
        }
        return acc
      }, [] as any)
      .sort((a: any, b: any) => this.productFiltersToShow.indexOf(a.id) - this.productFiltersToShow.indexOf(b.id))
  }

  filterVariations(event: any) {
    //remove filters that are null
    Object.keys(this.modelFilters).forEach((key) => {
      if (this.modelFilters[key] === null) {
        delete this.modelFilters[key]
      }
    })

    // if no filters selected, update the disabled status of filters and no further action neccessary
    if (Object.keys(this.modelFilters).length === 0 && !this.showVariantTable) {
      this.foundVariations = this.product.variations
      this.product.selectedVariantId = null
      this.updateFilters()
    }

    // filter the variations with the selected property values
    if (!this.showVariantTable) {
      this.foundVariations = this.product.variations.filter((variation: any) => {
        const properties = variation.properties.filter(
          (property: any) => Object.keys(this.modelFilters).indexOf(property.id) >= 0
        )
        return !properties.find((property: any) => {
          const filteredValue = this.modelFilters[property.id]
          return !filteredValue || filteredValue.value !== property.value
        })
      })
    }

    this.updateFilters()
    this.ProductDetailsLayer()

    // when only one variation is found, set the url
    if (this.foundVariations.length === 1 || this.product.selectedVariantId) {
      if (event !== null) this.fillEmptyFilters()
      this.updateBreadcrumbs(false)
      this.switchPageTitleAndSEO(false)
      window.history.replaceState(null, '', this.getVariant().url)
    } else {
      this.updateBreadcrumbs(true)
      this.switchPageTitleAndSEO(true)
      window.history.replaceState(null, '', this.product.url)
    }
  }

  updateBreadcrumbs(useParent: boolean) {
    const breadcrumbs = document.querySelector('.breadcrumbs')?.children
    if (breadcrumbs) {
      const lastBreadcrumb: any = breadcrumbs[breadcrumbs.length - 1]
      lastBreadcrumb.textContent = useParent ? this.product.title : this.getVariant().title
      lastBreadcrumb.href = useParent ? this.product.url : this.getVariant().url
      lastBreadcrumb.title = useParent ? this.product.title : this.getVariant().title
    }
  }

  switchPageTitleAndSEO(useParent: boolean) {
    const metaTitle = useParent ? this.product.title : this.getVariant().title
    document.title = metaTitle
    document.querySelector('meta[name="og:title"]')?.setAttribute('content', metaTitle)
  }

  fillEmptyFilters() {
    this.getVariant()
      .properties.filter((property: any) => this.productFiltersToShow.indexOf(property.id) >= 0)
      .map((property: any) => {
        this.modelFilters[property.id] = {
          unit: property.attributes.filter((item: any) => item.name === ATTR_UNITOFMEASURE)[0]?.value || '',
          $isDisabled: false,
          filterId: property.id,
          value: property.value
        }
      })
  }

  // update the isDisabled status of the filter values
  updateFilters() {
    this.filters.forEach((filter: IFilter) => {
      filter.values.forEach((value: IFilterValue) => {
        this.$set(value, '$isDisabled', true)
      })

      this.foundVariations.forEach((variation: any) => {
        const property = variation.properties.find((property: any) => property.id === filter.id)
        filter.values.find((value: IFilterValue) => {
          const isCorrectValue = property ? value.value === property.value : false
          if (isCorrectValue) {
            this.$set(value, '$isDisabled', false)
            return true
          }
          return false
        })
      })
    })
  }

  fillFilters() {
    if (this.product.selectedVariantId) {
      const selectedVariation = this.product.variations.find(
        (variant: any) => variant.id === this.product.selectedVariantId
      )
      selectedVariation.properties
        .filter((property: any) => this.productFiltersToShow.indexOf(property.id) >= 0)
        .map((property: any) => {
          this.modelFilters[property.id] = {
            unit: property.attributes.filter((item: any) => item.name === ATTR_UNITOFMEASURE)[0]?.value || '',
            $isDisabled: false,
            filterId: property.id,
            value: property.value
          }
        })
      this.foundVariations = [selectedVariation]

      this.filterVariations({} as any)
    }
  }

  ProductDetailsLayer(): void {
    if (!dataLayer) return
    dataLayer.push({ ecommerce: null })
    /* eslint-disable @typescript-eslint/camelcase */
    dataLayer.push({
      ecommerce: {
        items: [
          {
            item_name: this.isBeStore && this.variantSku ? this.variantSku : this.product.sku,
            //ID on BE will be same as SKU
            item_id: this.isBeStore && this.variantSku ? this.variantSku : this.product.id,
            item_category: this.categoryTitle,
            item_variant: this.heroTitle
          }
        ],
        detail: {
          products: [
            {
              name: this.isBeStore && this.variantSku ? this.variantSku : this.product.sku,
              //ID on BE will be same as SKU
              id: this.isBeStore && this.variantSku ? this.variantSku : this.product.id,
              category: this.categoryTitle,
              variant: this.heroTitle
            }
          ]
        }
      }
    })
  }

  created() {
    this.$nextTick(() => {
      this.foundVariations = this.product.variations
      this.filters = this.createFilters()
      this.switchPageTitleAndSEO(!this.product.selectedVariantId)
      this.fillFilters()
      this.ProductDetailsLayer()
    })
  }
}
